import React from 'react';
import { Outlet } from 'react-router-dom';
import { AuthProvider } from '../contexts/AuthContext';
import { NotificationProvider } from '../contexts/NotificationContext';
import { AuthModalProvider } from '../hooks/useAuthModal';

/**
 * This component wraps the AuthProvider inside the router context
 * so that navigation hooks can be used in auth operations
 */
const RouterAwareAuthProvider: React.FC = () => {
  return (
    <AuthProvider>
      <NotificationProvider>
        <AuthModalProvider>
          <Outlet />
        </AuthModalProvider>
      </NotificationProvider>
    </AuthProvider>
  );
};

export default RouterAwareAuthProvider;

